import { useState } from "react";
import { Link } from "react-router-dom";
import { Menu, X, Phone, LayoutDashboard } from "lucide-react";
import { Button } from "./ui/button";
import gprLogo from "@/assets/gpr-logo.png";

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);

  const navLinks = [
    { name: "Home", path: "/" },
    { name: "About Us", path: "/about" },
    { name: "Projects", path: "/projects" },
    { name: "Blog", path: "/blog" },
    { name: "Partner with Us", path: "/agent-partner" },
    { name: "Contact", path: "/contact" },
  ];

  return (
    <nav className="fixed top-0 w-full bg-background/95 backdrop-blur-md border-b border-border z-50 shadow-sm">
      <div className="container mx-auto px-4">
        <div className="flex items-center justify-between h-16">
          <Link to="/" className="flex items-center gap-3">
            <img src={gprLogo} alt="GPR Infra Logo" className="h-10 w-10" />
            <div className="text-2xl font-bold bg-gradient-to-r from-primary to-accent bg-clip-text text-transparent">
              GPR INFRA
            </div>
          </Link>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center gap-8">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className="text-foreground hover:text-primary transition-colors font-medium"
              >
                {link.name}
              </Link>
            ))}
            <Button size="sm" variant="outline" asChild className="gap-1.5">
              <Link to="/erp">
                <LayoutDashboard className="h-4 w-4" />
                ERP
              </Link>
            </Button>
            <Button asChild className="gap-2">
              <a href="https://wa.me/918297978080?text=Hi%20I%20am%20interested%20in%20your%20real%20estate%20projects" target="_blank" rel="noopener noreferrer">
                <Phone className="h-4 w-4" />
                WhatsApp Us
              </a>
            </Button>
          </div>

          {/* Mobile ERP Button + Menu Button */}
          <div className="md:hidden flex items-center gap-2">
            <Button size="sm" variant="outline" asChild className="gap-1 h-9 px-2.5">
              <Link to="/erp">
                <LayoutDashboard className="h-4 w-4" />
                ERP
              </Link>
            </Button>
            <button
              onClick={() => setIsOpen(!isOpen)}
              className="p-2 text-foreground"
            >
              {isOpen ? <X size={24} /> : <Menu size={24} />}
            </button>
          </div>
        </div>

        {/* Mobile Navigation */}
        {isOpen && (
          <div className="md:hidden py-4 border-t border-border">
            <div className="flex flex-col gap-4">
              {navLinks.map((link) => (
                <Link
                  key={link.path}
                  to={link.path}
                  onClick={() => setIsOpen(false)}
                  className="text-foreground hover:text-primary transition-colors font-medium px-2 py-2"
                >
                  {link.name}
                </Link>
              ))}
              <Button asChild className="gap-2 mt-2">
                <a href="https://wa.me/918297978080?text=Hi%20I%20am%20interested%20in%20your%20real%20estate%20projects" target="_blank" rel="noopener noreferrer">
                  <Phone className="h-4 w-4" />
                  WhatsApp Us
                </a>
              </Button>
            </div>
          </div>
        )}
      </div>
    </nav>
  );
};

export default Navbar;
